import {
  FxCheckboxField,
  FxInputField,
  FxPasswordInputField,
  FxSelectField,
} from 'axp-fx-common';
import labels from '../../constants/labels';
import fields from '../../constants/fields';

export const registerInitData = {
  otp: '',
  companyName: '',
  emailAddress: '',
  applUserFullNm: '',
  countryId: '226',
  phoneNo: '',
  userIdentifier: '',
  password: '',
  confPass: '',
  code: '',
  auth: '',
};

export const credentialsFormInitData = {
  userIdentifier: '',
  password: '',
  confirmPassword: '',
  securityPin: '',
  auth: '',
};

export const registerFormData = {
  otp: {
    id: fields.otp,
    name: fields.otp,
    component: FxInputField,
    label: labels.OTP,
    className: 'col-md-12 pad-0-lr',
    canExecuteFieldOnChange: false,
  },
  companyName: {
    id: fields.companyName,
    name: fields.companyName,
    component: FxInputField,
    label: labels.COMPANY_NM,
    disabled: true,
    className: 'col-md-6 pad-0-lr',
  },
  emailAddress: {
    id: fields.emailAddress,
    name: fields.emailAddress,
    component: FxInputField,
    label: labels.CONTACT_EMAIL,
    disabled: true,
    className: 'col-md-6 pad-0-r',
  },
  applUserFullNm: {
    id: fields.userFullName,
    name: fields.userFullName,
    component: FxInputField,
    label: labels.NAME,
    isRequired: true,
    className: 'col-md-6 pad-0-lr',
  },
  countryId: {
    id: fields.countryId,
    name: fields.countryId,
    component: FxSelectField,
    selectOptionFields: {
      id: 'ctryId',
      value: 'ctryId',
      name: 'ctryIntlDialingCd',
    },
    className: 'col-md-3 pad-0-lr',
  },
  phoneNo: {
    id: fields.phoneNumber,
    name: fields.phoneNumber,
    component: FxInputField,
    isRequired: true,
    className: 'col-md-9 pad-0-lr',
  },
  userIdentifier: {
    id: fields.userIdentifier,
    name: fields.userIdentifier,
    component: FxInputField,
    label: labels.USER_ID,
    isRequired: true,
    className: 'col-md-6 pad-0-lr',
  },
  password: {
    id: fields.password,
    name: fields.password,
    component: FxPasswordInputField,
    label: labels.PASSWORD,
    isRequired: true,
    className: 'col-md-6 pad-0-lr',
  },
  confirmPassword: {
    id: fields.confirmPassword,
    name: fields.confirmPassword,
    label: labels.CONFIRM_PASSWORD,
    isRequired: true,
    component: FxPasswordInputField,
    className: 'col-md-6 pad-0-r',
  },
  securityPin: {
    id: fields.securityPin,
    name: fields.securityPin,
    component: FxInputField,
    label: labels.SECURITY_PIN,
    isRequired: true,
    className: 'col-md-6 pad-0-lr',
    canExecuteFieldOnChange: false,
  },
  auth: {
    id: fields.auth,
    name: fields.auth,
    component: FxCheckboxField,
    type: 'checkbox',
  },
};
